// Dependencies
import * as Sentry from "@sentry/react";
import React from "react";
import { useRouteError } from "react-router-dom";

import { faCircleExclamation } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Spacer from "../Spacer";
// Components
import Text from "../Text";
// Styles
import css from "./page.module.scss";

export const PageError = () => {
	const routeError = useRouteError();

	// Handle different error types from React Router
	const error =
		routeError instanceof Error
			? routeError
			: new Error(typeof routeError === "string" ? routeError : "Unknown error");

	React.useEffect(() => {
		if (error && Sentry.getClient() !== undefined) {
			console.log("error:", error);
			Sentry.withScope((scope) => {
				scope.setTag("error_source", "page_error");
				scope.setContext("error_details", {
					message: error.message,
					stack: error.stack,
					url: window.location.href,
					timestamp: new Date().toISOString(),
					originalError: routeError, // Include original error for debugging
				});
				Sentry.captureException(error);
			});
		}
	}, [error, routeError]);

	return (
		<div className={css.page}>
			<div>
				<FontAwesomeIcon className={css.icon} icon={faCircleExclamation} />
			</div>
			<Spacer height={2} />
			<Text element="h1" size="paragraph-1" weight="bold">
				Application Error. Please try again later.
			</Text>
		</div>
	);
};
